import SectionEditDialog from "../SectionEditDialog";
import EarthlySectionEditInputs from "./EarthlySectionEditInputs";
import type {
  EarthlySectionEditModalProps,
  EarthlySectionId,
} from "../../../types";

const sectionTitles: Record<EarthlySectionId, string> = {
  "publishing-summary": "Publishing summary",
  "project-introduction": "Project introduction",
  "key-information": "Key information",
  scores: "Scores",
  "commercial-information": "Commercial information",
  "project-information": "Project information",
  benefits: "Benefits",
  "map-information": "Map information",
  "project-narratives": "Project narratives",
};

function EarthlySectionEditModal(props: EarthlySectionEditModalProps) {
  if (!props.section) return null;
  return (
    <SectionEditDialog
      {...props}
      title={sectionTitles[props.section]}
      testId="earthly-section-edit-modal"
      maxWidth="md"
    >
      <EarthlySectionEditInputs section={props.section} />
    </SectionEditDialog>
  );
}

export default EarthlySectionEditModal;
